export const adColors = ["#0ebaff", "#ea474c", "#fea501"];
